import { Container, Group, Grid, GridCol, Title, Button } from '@mantine/core';
import { IBankTransaction } from '../../../libraries/bank-transactions';
import { ICurrency } from '../../../libraries/currencies';
import ModalComponent from '../../components/modal';
import { formatDateTimeLabel } from '../../utils/date';
import { formatCurrAmount } from '../../utils/script';
import BankTransactionTable from '../../components/bank-transaction-table';
import { BankTransactionCurrencyInfo, processBankTransactionData } from './process-bank-data';
import { IconDownload } from '@tabler/icons-react';
import { useSelector } from 'react-redux';
import { AppState } from '../../client-redux/reducers';
import './styles.scss';

interface ShowBankTransactionProps {
  transaction?: IBankTransaction;
  openDetails?: boolean;
  hideBtn: () => void;
  lang: any;
  currencies: ICurrency[];
  getLog: () => void;
}

const ShowBankTransaction = ({
  transaction,
  //openDetails,
  hideBtn,
  lang,
  currencies,
  getLog
}: ShowBankTransactionProps) => {
  const region = useSelector<AppState, string>(state => state.login.user?.region || 'UTC');

  if (!transaction) return null;

  // Process the bank transaction using the new logic
  const processedData: BankTransactionCurrencyInfo[] = processBankTransactionData(transaction, currencies);

  return (
    <ModalComponent
      show={true}
      handleClick={hideBtn}
      title={lang.TRANSACTION_DETAILS}
      content={
        <Container className="bank-transaction-details">
          <Group>
            {/* Basic transaction info */}
            <Grid gap="sm">
              <GridCol span={6}>
                <Title order={4}>{lang.EQUIPMENT_LOCAL}</Title>
                <div>{transaction.entid}</div>
              </GridCol>
              <GridCol span={6}>
                <Title order={4}>{lang.EQUIPMENT_ID}</Title>
                <div>{transaction.eid}</div>
              </GridCol>
              <GridCol span={6}>
                <Title order={4}>{lang.GLOBAL_PERIOD}</Title>
                <div>{transaction.period}</div>
              </GridCol>
              <GridCol span={6}>
                <Title order={4}>{lang.GLOBAL_DATE_TIME}</Title>
                <div>{formatDateTimeLabel(transaction.dateTime, region)}</div>
              </GridCol>
              <GridCol span={6}>
                <Title order={4}>{lang.GLOBAL_AMOUNT}</Title>
                <div>
                  {transaction.cid
                    ? formatCurrAmount(transaction.value || 0, currencies.find(c => c.cid === transaction.cid)!)
                    : '-'}
                </div>
              </GridCol>
            </Grid>

            {/* Render each processed mc entry as its own table */}
            {processedData.map((block, idx) => {
              const originLabel =
                block.received && !block.dispensed
                  ? lang.CURRENCY_TABLE_CASH_IN
                  : !block.received && block.dispensed
                    ? lang.CURRENCY_TABLE_CASH_OUT
                    : `${lang.CURRENCY_TABLE_CASH_IN} / ${lang.CURRENCY_TABLE_CASH_OUT}`;

              return (
                <div key={idx} style={{ marginTop: 20 }}>
                  <Title order={5}>{originLabel}</Title>
                  <BankTransactionTable
                    key={block.currency.cid}
                    currency={block.currency}
                    cash={block.denominations ?? []}
                    values={[]}
                  />
                </div>
              );
            })}

            <Button color="#016273" radius="md" onClick={() => getLog()} style={{ marginTop: 20 }}>
              <IconDownload stroke={2} />
              Logs
            </Button>
          </Group>
        </Container>
      }
    />
  );
};

export default ShowBankTransaction;
